<template>
  <modal
    class="createAssetGroup"
    name="generateDepositModal"
    transition="pop-out"
    :width="500"
    :height="100"
    @opened="opened"
    @closed="closed"
    :clickToClose="false"
  >
    <div class="assets_modal_div w-100">
      <img
        src="@/assets/img/cancel-button.svg"
        class="close_assets_modal"
        @click="closeModal"
      />
      <div class="w-100" style="" v-if="!showRef">
        <div class="input__group__block mt-5" style="width: 90%">
          <h3 class="expense__header mt-3 text-center">
            {{ $t("text.generateDepositModal.generateDeposit") }}
          </h3>
          <label class="required"> {{ $t("text.form.amount") }} </label>
          <div class="input__block" ref="amount_input_div">
            <input
              type="number"
              placeholder="Amount"
              class="form-control"
              v-model="amount"
            />
          </div>
        </div>
        <!-- <div class="input__group__block mt-3" style="width: 90%">
          <label class="required">
            {{ $t("text.generateDepositModal.selectAccount") }}
          </label>
          <div class="input__block">
            <select v-model="accountId">
              <option value="select bank" disabled selected hidden>
                {{ $t("text.generateDepositModal.selectBank") }}
              </option>
              <option :value="acc.id" v-for="acc in banks" :key="acc.id">
                {{ acc.accountName }}({{ acc.accountNumber }})
              </option>
            </select>
          </div>
        </div> -->
        <!-- <div class="input__group__block mt-3" style="width: 90%">
          <label class="required"> {{ $t("text.form.date") }} </label>
          <div class="">
            <vue-ctk-date-time-picker
              id="DatePicker"
              v-model="scheduleDateTime"
              :onlyDate="true"
              color="#370F70"
              :autoClose="true"
              :locale="this.$root.$i18n.locale"
              format="YYYY-MM-DDTHH:mm:ss"
              formatted="DD/MM/YYYY"
              :label="$t('text.generateDepositModal.selectDate')"
            
            />
          </div>
        </div> -->

        <div class="text-center mt-4 pb-3" v-if="!showRef">
          <button
            @click="generateDeposit($event)"
            class="ep-btn ep-primary"
            style="border-radius: 3px; font-size: 16px"
            :disabled="isButtonDisabled ? true : null"
            :style="[
              isButtonDisabled
                ? { cursor: 'not-allowed' }
                : { cursor: 'pointer' },
            ]"
          >
            {{ $t("text.generateDepositModal.generateReference") }}<span></span>
          </button>
          <img
            src="@/assets/img/git_loader.gif"
            style="display: none"
            width="35px"
            class="ml-3 loader"
          />
        </div>
      </div>
    </div>
    <div class="p-5" v-if="showRef">
      <h2
        class="text-center primary-color"
        v-if="showRef"
        :class="refError ? 'mt-5' : 'mt-2'"
      >
        {{ $t("text.generateDepositModal.ref") }}: {{ reference.reference }}
      </h2>
      <h6 v-if="refError" class="modal-para mt-4 p-3">
        {{ $t("text.generateDepositModal.desc") }}
        <!-- {{ providedBank }} -->
        {{ $t("text.generateDepositModal.desc1") }} {{ reference.reference }}
        <!-- {{ $t("text.generateDepositModal.desc2") }} -->
      </h6>
    </div>
  </modal>
</template>
<script>
const MODAL_WIDTH = 1080;
import configObject from "@/config";
import JQuery from "jquery";
let $ = JQuery;

export default {
  name: "generateDepositModal",
  props: ["branchId"],
  data() {
    return {
      company: localStorage.getItem("companyDetails")
        ? JSON.parse(localStorage.getItem("companyDetails"))
        : null,
      modalWidth: MODAL_WIDTH,
      isButtonDisabled: false,
      accountId: "select bank",
      banks: [],
      scheduleDateTime: "",
      showRef: false,
      refError: false,
      reference: null,
      amount: "",
      providedBank: "",
    };
  },
  mounted() {
    this.getToday();
  },
  created() {
    this.$eventHub.$on("branch", (branch) => {
      this.branch = branch;
      document.title = `Link Bank Accounts :: ${branch.name} Retail Outlet`;
    });
    this.modalWidth =
      window.innerWidth < MODAL_WIDTH ? MODAL_WIDTH / 2 : MODAL_WIDTH;
  },
  watch: {
    accountId(id) {
      const account = this.banks.filter((bnk) => bnk.id === id)[0];
      this.providedBank = account.name;
    },
  },
  methods: {
  
    getToday() {
      let d = new Date(),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      var hours = d.getHours();
      var minutes = d.getMinutes();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      hours = hours < 10 ? "0" + hours : hours;
      var strTime = hours + ":" + minutes + " " + ampm;

      let todaysDate = [year, month, day].join("-") + " " + strTime;
      this.scheduleDateTime = todaysDate;
    },
    closeModal() {
      this.$modal.hide("generateDepositModal");
    },
    changeMode(mode) {
      this.mode = mode;
    },
    opened() {
      this.getBanks();
    },
    closed() {
      this.showRef = false;
      this.accountId == "select bank";
      this.amount = null;
    },
    getBanks() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Branch/BankAccounts/${this.branchId}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.banks = response.data;
        })
        .catch((error) => {});
    },
    selectBank(acc) {},
    generateDeposit($event) {
      $event.preventDefault();
      if (!this.amount) {
        this.$toast.open({
          message: this.$t("text.bBankAccounts.amountRequired"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      // if (this.accountId == "select bank") {
      //   this.$toast.open({
      //     message: this.$t("text.bBankAccounts.bankAccountRequired"),
      //     type: "error",
      //     duration: 3000,
      //   });
      //   return;
      // }

      // const dateTime = this.$moment(`${this.scheduleDateTime}`).format(
      //   "YYYY-MM-DD HH:mm:ss"
      // );
      // let newDateTime = new Date(dateTime);
      // let updatedDateTime = new Date(
      //   newDateTime.setHours(newDateTime.getHours() + 1)
      // ).toISOString();
      // let date = updatedDateTime;

      const data = {
        // accountId: this.accountId,
        amount: parseFloat(this.amount),
        // date: date,
      };

      this.isButtonDisabled = true;
      $(".loader").show();
      this.axios
        .post(
          `${configObject.apiBaseUrl}/Branch/DepositReference/${this.branchId}`,
          data,
          configObject.authConfig()
        )
        .then((res) => {
          this.reference = res.data;
          this.$eventHub.$emit("fetchReferences");
          // this.closeModal()
          this.showRef = true;
          this.$toast.open({
            message: this.$t("text.bBankDeposit.depositSuccess"),
            type: "success",
            duration: 2000,
          });
          $(".loader").hide();
          this.isButtonDisabled = false;
        })
        .catch(() => {
          this.$toast.open({
            message: this.$t("text.requests.failure"),
            type: "error",
            duration: 5000,
          });
          this.showRef = true;
          this.refError = true;
          $(".loader").hide();
          this.isButtonDisabled = false;
        });
    },
  },
};
</script>

<style scoped>
</style>
